<template>
    <div>
        <h5>Sale Info</h5>
        <div class="mb-3 mt-3">
            <div class="row">
                <div class="col-3">
                    <div class="form-group">
                        <label for="sale">Sale Name*</label>
                        <input type="text" class="form-control" id="sale" placeholder="Sale Name" v-model="sale_send.name">
                    </div>
                    <div class="form-group">
                        <label>Starts at*</label>
                        <datetime placeholder="Starts date" v-model="sale_send.starts_at" input-class="form-control" input-id="startDate" type="datetime" format="dd/MM/y HH:mm:ss"></datetime>
                    </div>
                    <div class="form-group">
                        <label>Ends at*</label>
                        <datetime placeholder="Ends date" v-model="sale_send.ends_at" input-class="form-control" input-id="endDate" type="datetime" format="dd/MM/y HH:mm:ss"></datetime>
                    </div>
                    <div class="form-group">
                        <label>Website</label>
                        <select class="form-control" v-model="website_id">
                            <option v-for="website in websites" :value="website.id">{{ website.name }}</option>                 
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <button class="btn btn-danger mr-1" @click="closeSection"><i class="far fa-times-circle"></i>&nbsp; Close</button>
            <button class="btn btn-primary mr-1" @click="save()"><i class="far fa-save"></i>&nbsp; Save</button>
            <button class="btn btn-success" @click="save('close')"><i class="fas fa-save"></i>&nbsp; Save &amp; close</button>
        </div>

        <loader :loading="loading"></loader>
    </div>
</template> 

<script>

import moment from 'moment';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import loader from './loader.vue'

export default {

    components: {
        moment,
        datetime: Datetime,
        loader
    },

    data() {
        return {
            sale_send: {},
            website_id: null,
            websites: {},
            loading: true,
        };
    },

    props: {
        sale: Object,
    },

    mounted(){
        if (this.sale.websites.length > 0) {
            this.website_id = this.sale.websites[0].id;
        }

        this.sale_send = this.sale;
        
        // Format for the datetime picker
        this.update_info(); 

        this.get_websites();

        history.pushState({page: 0}, "", window.location.pathname + "?page=info");  
    },

    methods: {
        save(close) {
            if(this.load_count > 0){
                this.loading = true;
            } else if(close){
                this.closeSection();
            }
            axios.patch('/sales/' + this.sale.id ,{
                name: this.sale_send.name,
                starts_at: this.db_date(this.sale_send.starts_at),                        
                ends_at: this.db_date(this.sale_send.ends_at),
                website_id: [this.website_id],
            })
            .then(function (response) {
                this.sale_send = response.data.sale;
                this.update_info();
                this.loading = false;
            }.bind(this))
            .catch(function (error) {
                this.loading = false;
            }.bind(this))
            if(close){
                this.closeSection();
            }
        },
        get_websites(){
            axios.get('/websites/list')
            .then(function (response) {
                this.loading = false
                this.websites = response.data.websites;
            }.bind(this))
            .catch(function (error) {
                // handle error
                alert(error);
            })
        },
        update_info(){
            this.sale_send.starts_at = this.format_dates(this.sale_send.starts_at);
            this.sale_send.ends_at = this.format_dates(this.sale_send.ends_at);  
        },
        closeSection (event) {
            history.pushState({page: 0}, "", window.location.pathname); 
            this.$emit('closeChild', false);
        },
        format_dates: function(date){
            return moment(date).format('YYYY-MM-DDTHH:mm:ss');
        },
        db_date: function (date) {
            return moment(date).format('YYYY-MM-DD HH:mm:ss');
        },
    },
};
</script>